export const growth = [
  {
    field: "500 million products",
    description: "available to shop across the catalog",
  },
  {
    field: "40,000 stores",
    description: "from local grocers to chain stores",
  },
  {
    field: "5,500+ cities",
    description: "served across the U.S. & Canada",
  },
  {
    field: "Millions of orders",
    description: "delivered or picked up yearly",
  },
];
